export default __webpack_public_path__ + "static/media/127.01b784b7.jpg";